export default __webpack_public_path__ + "static/media/tsi_help2.3ce69a34.png";